<template>
  <v-content class="page panel-vendor" width="1222px">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="top-container">
          <v-card class="fill-width table_theme card-theme custom-container">
            <v-card-title class="medium-font" style="letter-spacing: normal">
              <h2 class="medium-font billing-title">
                <span style="font-weight: 500 !important; color: #041332 !important;">Welcome, </span>
                <strong style="font-weight: 600 !important;">{{ current_user.first_name }}</strong>
              </h2>
              <!--<v-spacer></v-spacer>-->
              <!--<div-->
                <!--class="custom-o-search-bar"-->
                <!--style=""-->
              <!--&gt;-->
                <!--<v-text-field-->
                  <!--placeholder="Search..."-->
                  <!--single-line-->
                  <!--hide-details-->
                  <!--class="input_search"-->
                  <!--color="#198beb"-->
                  <!--width="316px"-->
                <!--&gt;-->
                  <!--<img-->
                    <!--:src="require('@/assets/img/search.svg')"-->
                    <!--slot="prepend"-->
                    <!--alt="help"-->
                    <!--class="info-tooltip"-->
                  <!--/>-->
                <!--</v-text-field>-->
              <!--</div>-->
              <!--<v-btn-->
                <!--text-->
                <!--class="custom-o-sliders"-->
                <!--style="position: relative;top: 5px; left: 20px"-->
              <!--&gt;-->
                <!--<img :src="require('@/assets/img/settings.svg')" alt />-->
              <!--</v-btn>-->
            </v-card-title>
            <v-divider class="mt-1" style="max-width: 1096px"></v-divider>
            <v-card-text>
              <div class="mt-1 ml-2 pb-8 cont-admin_cards" style="margin-right: 44px;">
                <div @click="$router.push('/vendor/users')" class="cont-admin_cards__item colors-a">
                  <div class="cont-admin_cards__container">
                    <h4 class="cont-admin_cards__title">Users</h4>
                    <p class="cont-admin_cards__text">
                      Manage your user list. Add, Edit, Delete and
                      <br />view details of your current user accounts.
                    </p>
                    <a @click="$router.push('/vendor/users')" class="cont-admin_cards__icon">
                      <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt />
                    </a>
                  </div>
                </div>

                <div
                  @click="$router.push('/vendor/app-display-information')"
                  class="cont-admin_cards__item cont-admin_cards__item--b colors-c"
                >
                  <div class="cont-admin_cards__container color2">
                    <h4 class="cont-admin_cards__title">
                      App Display
                      <br />Information
                    </h4>
                    <p class="cont-admin_cards__text">
                      Customize how your company information
                      <br />is viewed within the app.
                    </p>
                    <a
                      @click="$router.push('/vendor/app-display-information')"
                      class="cont-admin_cards__icon"
                    >
                      <img :src="require('@/assets/img/dash-box-arrow-black.svg')" alt />
                    </a>
                  </div>
                </div>

                <div
                  @click="$router.push('/vendor/billing')"
                  class="cont-admin_cards__item colors-d"
                >
                  <div class="cont-admin_cards__container">
                    <h4 class="cont-admin_cards__title">Billing</h4>
                    <p class="cont-admin_cards__text">
                      Manage your billing account,
                      <br />view & download invoices.
                    </p>
                    <a @click="$router.push('/vendor/billing')" class="cont-admin_cards__icon">
                      <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt />
                    </a>
                  </div>
                </div>

<!--                <div-->
<!--                  @click="$router.push('/vendor/report')"-->
<!--                  class="cont-admin_cards__item cont-admin_cards__item&#45;&#45;b colors-b"-->
<!--                >-->
<!--                  <div class="cont-admin_cards__container color2">-->
<!--                    <h4 class="cont-admin_cards__title">Reports</h4>-->
<!--                    <p class="cont-admin_cards__text">-->
<!--                      Analyze your client engagements through-->
<!--                      <br />advanced search and filter capabilities.-->
<!--                    </p>-->
<!--                    <a @click="$router.push('/vendor/report')" class="cont-admin_cards__icon">-->
<!--                      <img :src="require('@/assets/img/dash-box-arrow-black.svg')" alt />-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->

                <div
                  @click="$router.push('/vendor/invoices')"
                  class="cont-admin_cards__item colors-e"
                >
                  <div class="cont-admin_cards__container">
                    <h4 class="cont-admin_cards__title">#Invoice</h4>
                    <p class="cont-admin_cards__text">
                      View documents that were created using #invoice in the app and web chat
                    </p>
                    <a @click="$router.push('/vendor/invoices')" class="cont-admin_cards__icon">
                      <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt />
                    </a>
                  </div>
                </div>

                <div
                  @click="$router.push('/vendor/support')"
                  class="cont-admin_cards__item colors-f"
                >
                  <div class="cont-admin_cards__container">
                    <h4 class="cont-admin_cards__title">Support</h4>
                    <p class="cont-admin_cards__text">
                      Have a question you need answered?
                      <br />Message us here.
                    </p>
                    <a @click="$router.push('/vendor/support')" class="cont-admin_cards__icon">
                      <img :src="require('@/assets/img/dash-box-arrow-white.svg')" alt />
                    </a>
                  </div>
                </div>
                <div class="cont-admin_cards__item colors-transparent"></div>
              </div>
            </v-card-text>
            <div class="sombra"></div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Login",
  created() {
    this.$store.dispatch("Banner/show");
  },
  data: () => ({
    search: "",
    phoneNumber: "",
    email: "",
  }),
  computed: {
    ...mapGetters({ current_user: ["Authenticate/current_user"] }),
  },
  components: {},
  methods: {},
};
</script>

<style lang="scss">
.panel-vendor {
  .custom-container {
    max-width: 1222px !important;
    min-height: 558px;
    margin-bottom: 50px !important;
  }

  /* estilo para pregunta */
  .azul {
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: -0.31px;
    margin-right: 11px;
  }

  /* estilo para link ContactUs*/
  .azul-contact {
    font-size: 15px;
    font-weight: 700;
  }

  /* estilo para texto debajo de login */
  .v-application .py-2 {
    color: #878787;
    font-size: 15px;
    font-weight: 500;
  }

  .btn-t {
    width: 155px;
    height: 48px;
    color: white;
    box-shadow: 0 5px 18px rgba(51, 51, 51, 0.13);
    border-radius: 24px;
    margin: 0 auto;
  }

  .ui-label {
    color: #061d47;
    /*!important;*/
    font-size: 20px !important;
    font-weight: bold !important;
  }

  .padd-log {
    padding: 0 65px;
  }

  .card-theme {
    -webkit-box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
    -moz-box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
    box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
  }

  .v-input__control {
    width: 34px;
  }

  .fa-theme--a {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #29abe2;
    font-size: 10px !important;
  }

  @media (max-width: 768px) {
    .v-application .px-10 {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }

    .padd-log {
      padding: 0;
    }
  }
  @media (max-width: 450px) {
    .cont-admin_cards__item {
      height: auto;
    }
    .v-card__title {
      padding: 0;
    }
  }
}
</style>
